'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZINDEX = exports.SPACE = exports.DROP_SHADOW = exports.RADII = exports.COLOR_NAME = exports.SEMANTIC_COLOR_NAME = exports.FONT_FACE = exports.FONT_WEIGHT = exports.LINE_HEIGHTS = exports.TYPOGRAPHY = exports.FONT_SIZE = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FONT_SIZE = exports.FONT_SIZE = {
  XXXSMALL: 'xxxsmall',
  XXSMALL: 'xxsmall',
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
  XXLARGE: 'xxlarge',
  XXXLARGE: 'xxxlarge',
  XXXXLARGE: 'xxxxlarge'
};

var TYPOGRAPHY = exports.TYPOGRAPHY = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  LARGEBODY: 'largebody',
  SMALLBODY: 'smallbody',
  METAINFO: 'metainfo',
  SMALLCAPS: 'smallcaps',
  LEGAL: 'legal'
};

var LINE_HEIGHTS = exports.LINE_HEIGHTS = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
  XXLARGE: 'xxlarge',
  XXXLARGE: 'xxxlarge'
};

var FONT_WEIGHT = exports.FONT_WEIGHT = {
  ULTRALIGHT: 'ultraLight',
  LIGHT: 'light',
  REGULAR: 'regular',
  SEMIBOLD: 'semibold',
  BOLD: 'bold'
};

var FONT_FACE = exports.FONT_FACE = {
  MONOSPACE: 'monospace',
  BODY: 'body'
};

var SEMANTIC_COLOR_NAME = exports.SEMANTIC_COLOR_NAME = {
  PRIMARY1: 'primary1',
  PRIMARY2: 'primary2',
  SECONDARY1: 'secondary1',
  SECONDARY2: 'secondary2',
  SECONDARY3: 'secondary3',
  SECONDARY4: 'secondary4',
  SECONDARY5: 'secondary5',
  SECONDARY6: 'secondary6',
  FUNCTIONAL1: 'functional1',
  FUNCTIONAL2: 'functional2',

  CTA_PRIMARY: 'ctaPrimary',
  CTA_SECONDARY: 'ctaSecondary',
  FOCUS_PRIMARY: 'focusPrimary',

  TEXT_PRIMARY: 'textPrimary',
  TEXT_SECONDARY: 'textSecondary',
  TEXT_TERTIARY: 'textTertiary',

  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
  LINK: 'link',
  DISABLED: 'disabled',
  STROKE: 'stroke',

  DARK: 'dark',
  DARK_SUBCOPY: 'darkSubcopy',
  DARK_TERTIARY: 'darkTertiary',
  DARK_GHOST: 'darkGhost',
  LIGHT: 'light',
  LIGHT_SUBCOPY: 'lightSubcopy',
  LIGHT_TERTIARY: 'lightTertiary',
  LIGHT_GHOST: 'lightGhost'
};

var COLOR_NAME = exports.COLOR_NAME = (0, _extends3.default)({}, SEMANTIC_COLOR_NAME);

var RADII = exports.RADII = {
  CORNER: 'corner',
  ROUND_CORNER_2X: 'roundCorner2x',
  ROUND: 'round',
  ROUND_CORNER_1X: 'roundCorner1x'
};

var DROP_SHADOW = exports.DROP_SHADOW = {
  Z0: 'z0',
  Z1: 'z1',
  Z2: 'z2',
  Z3: 'z3',
  Z4: 'z4',
  Z5: 'z5'
};

var SPACE = exports.SPACE = {
  NONE: 'none',
  XSMALL: 'xsmall',
  SMALL: 'small',
  SMEDIUM: 'smedium',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
  XXLARGE: 'xxlarge',
  XXXLARGE: 'xxxlarge'
};

var ZINDEX = exports.ZINDEX = {
  DRAWER: 'drawer',
  MODAL: 'modal',
  TOOLTIP: 'tooltip',
  OVERLAY: 'overlay',
  NAV: 'nav',
  SUBNAV: 'subnav'
};